import React from "react";
import "./protection.css";
import {
  Container,
  Icon,
  IconList,
  Layout,
  Padding,
  Text,
} from "@kidslivesafe/sc-react";

import { useAppSelector } from "../../../hooks/hooks";
import { selectProtectionState } from "../../../features/profileProtection/profileProtectionSlice";

const RemovalOptions: React.FC = () => {
  const { profileName, profileLocation, defaultBrokerSites } = useAppSelector(
    selectProtectionState,
  );
  const sourceCount = defaultBrokerSites.length;
  const sourceLabel = sourceCount === 1 ? "source" : "sources";
  const savedProfileName = (profileName || "this profile").trim();
  const savedProfileLocation = (profileLocation || "").trim();

  return (
    <Layout type="flex" flexProps={{ direction: "column", gap: "md" }}>
      {/* --- On-platform visibility --- */}
      <Layout type="flex" flexProps={{ direction: "column", gap: "md" }}>
        <Container border borderColor="primary" bodyBorderRadius>
          <Padding space="md">
            <Layout type="flex" flexProps={{ direction: "row" }}>
              <Padding right="md" top="xxs">
                <Icon
                  name={IconList.IconMultipleStack}
                  size={30}
                  iconColor="var(--sc-text-color-primary)"
                />
              </Padding>
              <Layout
                type="flex"
                flexProps={{ direction: "column", gap: "xs" }}
              >
                <Layout
                  type="flex"
                  flexProps={{ gap: "xs", alignItems: "center" }}
                >
                  <Text fontWeight="semibold" size="sm">
                    We've identified {sourceCount} {sourceLabel} that may be
                    exposing your data
                  </Text>
                </Layout>
                <Text size="xs">
                  By confirming, we'll send removal requests to each source on
                  your behalf. Most begin processing within a few days, though
                  some can take up to 30 days.
                </Text>
                <Layout
                  type="flex"
                  flexProps={{ direction: "column", gap: "xxs" }}
                >
                  <Layout
                    type="flex"
                    flexProps={{ gap: "xs", alignItems: "center" }}
                  >
                    <Icon
                      name={IconList.IconShield}
                      size={14}
                      iconColor="var(--sc-text-color-primary)"
                    />
                    <Text size="xs" color="dark-gray">
                      Requesting removal for{" "}
                      <Text
                        tag="span"
                        size="xs"
                        color="base"
                        fontWeight="semibold"
                      >
                        {savedProfileName}
                      </Text>
                      {savedProfileLocation ? (
                        <>
                          {" in "}
                          <Text
                            tag="span"
                            size="xs"
                            color="base"
                            fontWeight="semibold"
                          >
                            {savedProfileLocation}
                          </Text>
                        </>
                      ) : null}
                    </Text>
                  </Layout>
                  <Layout
                    type="flex"
                    flexProps={{ gap: "xs", alignItems: "center" }}
                  >
                    <Icon
                      name={IconList.IconEye}
                      size={14}
                      iconColor="var(--sc-text-color-primary)"
                    />
                    <Text size="xs" color="dark-gray">
                      Your info will be hidden from others on this site, but
                      you'll still be able to view it.
                    </Text>
                  </Layout>
                  <Layout
                    type="flex"
                    flexProps={{ gap: "xs", alignItems: "center" }}
                  >
                    <Icon
                      name={IconList.IconSearch}
                      size={14}
                      iconColor="var(--sc-text-color-primary)"
                    />
                    <Text size="xs" color="dark-gray">
                      We regularly add new sites and recheck on your behalf
                    </Text>
                  </Layout>
                  <Layout
                    type="flex"
                    flexProps={{ gap: "xs", alignItems: "center" }}
                  >
                    <Icon
                      name={IconList.IconMonitoring}
                      size={14}
                      iconColor="var(--sc-text-color-primary)"
                    />
                    <Text size="xs" color="dark-gray">
                      You'll get updates as removals are confirmed
                    </Text>
                  </Layout>
                </Layout>
              </Layout>
            </Layout>
          </Padding>
        </Container>
      </Layout>
    </Layout>
  );
};

export default RemovalOptions;
